import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import BitrateGraphs from 'components/Web_User_Interface/1440p_Series/Multimedia/Video/Graphs/BandwidthGraphsFlyout';
import CompressionGraphs from 'components/Web_User_Interface/1440p_Series/Multimedia/Video/Graphs/CompressionGraphsFlyout';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Video/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/MultimediaPerm';
import UpdateBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/PrimaryBoxUpdates';
import VideoTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Video/Tables/videoTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Multimedia Menü // Videoeinstellungen",
  "path": "/Web_User_Interface/1440p_Serie/Multimedia/Video/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die Videoeinstellungen erlauben es, die Qualität von allen 3 Videostreams Ihrer Kamera einzustellen. Bitte beachten Sie, dass eine hohe Qualität in den Videoeinstellungen auch gleichzeitig hohe Hardware- und Bandbreitenansprüche mit sich bringt. Richten Sie die Videoeinstellungen ein, um ein flüssiges Video zu erhalten.",
  "image": "./WebUI_1440p_SearchThumb_Multimedia_Video.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Multimedia_Video.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <SEOHelmet title='Multimedia Menü // Videoeinstellungen' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Die Videoeinstellungen erlauben es, die Qualität von allen 3 Videostreams Ihrer Kamera einzustellen. Bitte beachten Sie, dass eine hohe Qualität in den Videoeinstellungen auch gleichzeitig hohe Hardware- und Bandbreitenansprüche mit sich bringt. Richten Sie die Videoeinstellungen ein, um ein flüssiges Video zu erhalten.' image='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Video.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Video.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Multimedia/Video/' locationFR='/fr/Web_User_Interface/1440p_Series/Multimedia/Video/' crumbLabel="Video Settings" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "multimedia-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#multimedia-men%C3%BC",
        "aria-label": "multimedia menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Multimedia Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Mit den Videoeinstellungen können Sie die Qualität aller 3 Videoströme Ihrer Kamera einstellen. Bitte beachten Sie, dass hohe Qualitätseinstellungen mit hohen Anforderungen an Ihre Computerhardware und Netzwerkbandbreite einhergehen. Passen Sie die Videoqualität entsprechend an, um ein flüssiges Video zu erhalten. Sehen Sie auch den Punkt `}<a parentName="p" {...{
        "href": "/de/Aussenkameras/IN-9408_WQHD/Video_Streaming/"
      }}>{`RTSP-Streaming`}</a>{` für den Zugriff auf die Kamera-Streams mit Software von Drittanbietern:`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`WQHD`}</strong>{` / `}<em parentName="li">{`1440p`}</em>{` / `}<em parentName="li">{`2560x1440 Pixel`}</em>{` / `}<em parentName="li">{`3.68 Megapixel`}</em>{` / `}<em parentName="li">{`h.265a`}</em></li>
      <li parentName="ol"><strong parentName="li">{`Full HD`}</strong>{` / `}<em parentName="li">{`1080p`}</em>{` / `}<em parentName="li">{`1920x1080 Pixel`}</em>{` / `}<em parentName="li">{`2.07 Megapixel`}</em>{`  / `}<em parentName="li">{`h.264hp`}</em></li>
      <li parentName="ol"><strong parentName="li">{`WXGA`}</strong>{` / `}<em parentName="li">{`360p`}</em>{` / `}<em parentName="li">{`640x360 Pixel`}</em>{` / `}<em parentName="li">{`0.23 Megapixel`}</em>{` / `}<em parentName="li">{`h.264hp`}</em></li>
    </ol>
    <p>{`Beachten Sie, dass Sie für alle verfügbaren Streams unterschiedliche Werte einstellen können. Die `}<strong parentName="p">{`Web-Benutzeroberfläche`}</strong>{` verwendet standardmäßig den `}<strong parentName="p">{`zweiten Stream`}</strong>{`. Unsere mobilen Apps verwenden den zweiten Stream und den dritten für die Kameravorschau.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/c2045fb96860650c3edb132b7b754208/e24fe/1440p_Settings_Multimedia_Video.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.434782608695656%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAA7rAAAO6wFxzYGVAAACh0lEQVQoz3WSS08TYRSG+yeMkRqLhda0pdRLlIKdmV6GdiiUdi7fTKdTKhXwCoIajUYhSmLCgstCE9fiyg24MDFuNFFj4iUx/KLHtBQFo4sn510935vvHF9/fz/xeJy+eD+RcA+SfpXxB1sUbm2i3X5JbmGT7HyHTlYXXmAubTNgLHB+cIBEIkGXv4tAIIAvFosRjUaJxmKEe4OkSx61u88Q86tUb20gFtZ3ubmB1c4biPk13DtPmbh2n6KqcuZMknj8JInE6V3hHuHwCVJDA4jyCKJcZNIT1B0do1Roo4/lMTtZUxUezE0zO3ERJVlAmFNk0wV87XYdQqEQkixTn2jg1jxqXh1hO+iG2ca0BJawEZbAcCdxHI+pSpNGocHkWJOR4Ty+SCTSlu02DCNJEq7rYts2hmGg63qbVlbVYWRZRpJSKEqaSmWU5gWb66bJ+qyN5+b+Lax53m/hnnRXqKLIEkODg0hKhvJ4kWI+yc25Js9Xb+AYyf83FEIckLWmaVqYTh3LNDDcJo7rsbbymC+fP/Bza5NZO/9ny63Z/sNWw1qNarWKZVkHhZaF5Xjtx0pjo9x/uMiPb5/4+v4tO9uvWb/U2Hc2e0uRJOpeDbfq4Oz7R8MwKWgjZDNp1GyWoeQgy8tL7Hx8w8dXL/n+bouVK95fZxMKkZIkdNtjTHcoV/YtpVIip5xHllOck2XOyhKl0RFG8yoVLY+ZU0id6jvYsDcUIqNIPJmzWJ3XmfJMKoaFZeqIC9cwLi9SrV3mdkHj3niFjCRz6PBhuvx+jvj9HD0W2N8wSqhz2I+mVFZmMlTLKrm8hpZX0ayLFKeXMMQMd9NZ7g1ryMkkge5ueoJBgi2OH+cXvRfIf/8cONAAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c2045fb96860650c3edb132b7b754208/e4706/1440p_Settings_Multimedia_Video.avif 230w", "/de/static/c2045fb96860650c3edb132b7b754208/d1af7/1440p_Settings_Multimedia_Video.avif 460w", "/de/static/c2045fb96860650c3edb132b7b754208/7f308/1440p_Settings_Multimedia_Video.avif 920w", "/de/static/c2045fb96860650c3edb132b7b754208/068a9/1440p_Settings_Multimedia_Video.avif 1073w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/c2045fb96860650c3edb132b7b754208/a0b58/1440p_Settings_Multimedia_Video.webp 230w", "/de/static/c2045fb96860650c3edb132b7b754208/bc10c/1440p_Settings_Multimedia_Video.webp 460w", "/de/static/c2045fb96860650c3edb132b7b754208/966d8/1440p_Settings_Multimedia_Video.webp 920w", "/de/static/c2045fb96860650c3edb132b7b754208/e9b9c/1440p_Settings_Multimedia_Video.webp 1073w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c2045fb96860650c3edb132b7b754208/81c8e/1440p_Settings_Multimedia_Video.png 230w", "/de/static/c2045fb96860650c3edb132b7b754208/08a84/1440p_Settings_Multimedia_Video.png 460w", "/de/static/c2045fb96860650c3edb132b7b754208/c0255/1440p_Settings_Multimedia_Video.png 920w", "/de/static/c2045fb96860650c3edb132b7b754208/e24fe/1440p_Settings_Multimedia_Video.png 1073w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/c2045fb96860650c3edb132b7b754208/c0255/1440p_Settings_Multimedia_Video.png",
              "alt": "Web User Interface - 1440p Series - Multimedia Video",
              "title": "Web User Interface - 1440p Series - Multimedia Video",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "video-bitrate",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#video-bitrate",
        "aria-label": "video bitrate permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Video Bitrate`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <UpdateBox mdxType="UpdateBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Dies is eine Übersicht über die Bandbreiten bzw. Speicherplatz Anforderung für den Livevideo Stream und die Videoaufnahmen. Beachten Sie, dass die Einstellung der Auflösung und Bitrate einen sehr großen Einfluß auf beide Größen haben.`}</p>
    <BitrateGraphs mdxType="BitrateGraphs" />
    <h2 {...{
      "id": "h26x-profile",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#h26x-profile",
        "aria-label": "h26x profile permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`h.26x Profile`}</h2>
    <p>{`h.26x ist eine "Familie" von Standards, die eine Reihe verschiedener "Profile" umfasst. Alle diese Profile stützen sich stark auf die zeitliche Komprimierung und die Bewegungsvorhersage, um die Datenmenge des Streams zu reduzieren. Die drei am häufigsten verwendeten Profile sind `}<strong parentName="p">{`Baseline`}</strong>{`, `}<strong parentName="p">{`Main`}</strong>{` und `}<strong parentName="p">{`High`}</strong>{` beim `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`h.264`}</code>{`. Jedes dieser Profile definiert die spezifischen Kodierungstechniken und Algorithmen, die zur Komprimierung von Dateien verwendet werden.`}</p>
    <h3 {...{
      "id": "baseline-profil",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#baseline-profil",
        "aria-label": "baseline profil permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Baseline Profil`}</h3>
    <p>{`Dies ist das einfachste Profil (`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`h.264bp`}</code>{`), das vor allem für Geräte mit geringem Stromverbrauch und niedrigen Kosten verwendet wird, einschließlich einiger Videokonferenz- und mobiler Anwendungen. Mit Baseline-Profilen kann ein Kompressionsverhältnis von etwa 1000:1 erreicht werden, d. h. ein Stream von 1 Gbit/s kann auf etwa 1 Mbit/s komprimiert werden. Sie verwenden ein 4:2:0-Chrominanz-Sampling, d. h. Farbinformationen werden mit der halben vertikalen und horizontalen Auflösung der Schwarz-Weiß-Informationen abgetastet.`}</p>
    <h3 {...{
      "id": "main-profil",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#main-profil",
        "aria-label": "main profil permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Main Profil`}</h3>
    <p>{`Das Hauptprofil (`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`h.264mp`}</code>{`) enthält alle Funktionen von Baseline, jedoch mit verbesserten Algorithmen für die Bildvorhersage. Es wird für digitale SD-Fernsehsendungen verwendet, die das MPEG-4-Format verwenden, nicht aber für HD-Sendungen.`}</p>
    <h3 {...{
      "id": "high-profil",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#high-profil",
        "aria-label": "high profil permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`High Profil`}</h3>
    <p>{`h.264 High Profile (`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`h.264hp`}</code>{`) ist das effizienteste und leistungsstärkste Profil der h.264-Familie und ist das wichtigste Profil für die Übertragung und Speicherung auf Datenträgern, insbesondere für HDTV- und Bluray-Datenträgerformate. Es kann ein Kompressionsverhältnis von etwa 2000:1 erreichen. Das High Profile verwendet außerdem eine adaptive Transformation, bei der zwischen 4x4- und 8x8-Pixelblöcken gewählt werden kann. So werden beispielsweise 4x4-Blöcke für detailreiche Bildteile verwendet, während detailarme Teile mit 8x8-Blöcken komprimiert werden. Das Ergebnis ist die Beibehaltung der Videobildqualität bei gleichzeitiger Reduzierung der erforderlichen Netzwerkbandbreite um bis zu 50 Prozent. Durch Anwendung der h.264 High Profile-Komprimierung kann ein Stream mit 1 Gbit/s auf etwa 512 Kbit/s komprimiert werden.`}</p>
    <h3 {...{
      "id": "high-efficiency",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#high-efficiency",
        "aria-label": "high efficiency permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`High Efficiency`}</h3>
    <p><em parentName="p">{`High Efficiency Video Coding`}</em>{` (`}<strong parentName="p">{`HEVC`}</strong>{`), auch bekannt als `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`h.265a`}</code>{`, ist ein Videokompressionsstandard, der als Nachfolger des weit verbreiteten `}<strong parentName="p">{`Advanced Video Coding`}</strong>{` (AVC oder `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`h.264`}</code>{`) entwickelt wurde. Im Vergleich zu AVC bietet HEVC eine um 25 % bis 50 % bessere Datenkomprimierung bei gleicher Videoqualität bzw. eine wesentlich bessere Videoqualität bei gleicher Bitrate.`}</p>
    <p>{`Der erste Stream, mit der höchsten Auflösung, wird standardmäßig in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`h.265`}</code>{` ausgegeben, um eine möglichst geringe Dateigröße - bei bester Qualität - bei den Videoaufnahmen zu gewährleisten. Beim zweiten, mittleren, in der WebUI verwendeten Stream wird jedoch `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`h.264`}</code>{` voreingestellt, da die `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`h.265`}</code>{` Komprimierung in `}<a parentName="p" {...{
        "href": "https://caniuse.com/hevc"
      }}>{`Webbrowsern noch nicht universal unterstützt`}</a>{` wird.`}</p>
    <CompressionGraphs mdxType="CompressionGraphs" />
    <EuiSpacer mdxType="EuiSpacer" />
    <VideoTable mdxType="VideoTable" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      